import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/recents/',
  headTitle: 'Font Generator - Recent Used Fonts',
  headDescription:
    'The Picsart Font Generator tool can help you convert any text into fancy and eye-catching fonts in seconds, in just a few clicks.',
  heading: 'Recently Used Fonts',
  description:
    'On this page, we will show your recently used fonts so that you can easily continue where you left off.',
  selectedCategory: FontCategory.Recents,
  noIndex: true,
  inputPlaceholder: 'Customize your fonts here…',
};

export default props;
